module.exports = __webpack_public_path__ + "media/images/avatar-baaeb5b7a0334caa02fbfa0b810384f1.png";